function escapeHTML(text: string = ""): string {
  return text
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#039;");
}

export const createMSGPreviewTemplate = (msg: any) => {
  const senderName = escapeHTML(msg?.senderName ?? "Unknown Sender");
  const senderEmail = escapeHTML(msg?.senderEmail ?? "");
  const subject = escapeHTML(msg?.subject ?? "No Subject");

  const recipients = (msg?.recipients ?? [])
    .map((r: any) => `${escapeHTML(r.name)} (${escapeHTML(r.email)})`)
    .join(", ");

  const bodyContent =
    msg?.bodyHTML || `<p>${escapeHTML(msg?.body ?? "No message content.")}</p>`;

  const attachments = (msg?.attachments ?? [])
    .map((att: any) => {
      const name = escapeHTML(att?.name ?? "Unnamed file");
      const url = att?.url ?? "#";
      return `<li>${name}</li>`;
    })
    .join("");

  const attachmentsSection = attachments
    ? `
      <hr/>
      <div class="attachments">
        <h3>📎 Attachments</h3>
        <ul>${attachments}</ul>
      </div>
    `
    : "";

  const htmlContent = `
    <html>
      <head>
        <title>${subject}</title>
        <style>
          body {
            font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
            background-color: #f9f9f9;
            margin: 0;
            padding: 2rem;
            color: #333;
          }
          .container {
            max-width: 800px;
            margin: 0 auto;
            background: #fff;
            padding: 2rem;
            border-radius: 10p;
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
          }
          h2 {
            margin-top: 0;
            color: #0078D4;
          }
          h3 {
            color: #0078D4;
            margin-top: 1.5rem;
          }
          p {
            margin: 0.5rem 0;
          }
          strong {
            color: #444;
          }
          hr {
            margin: 1.5rem 0;
            border: none;
            height: 1px;
            background: #ddd;
          }
          .body-content {
            margin-top: 1rem;
            line-height: 1.6;
          }
          .attachments ul {
            padding-left: 1.2rem;
          }
          .attachments li {
            margin: 0.3rem 0;
          }
          .attachments a {
            color: #0078D4;
            text-decoration: none;
          }
        </style>
      </head>
      <body>
        <div class="container">
          <h2>📨 Message Preview</h2>
          <p><strong>From:</strong> ${senderName} (${senderEmail})</p>
          <p><strong>To:</strong> ${recipients}</p>
          <p><strong>Subject:</strong> ${subject}</p>
          <hr/>
          <div class="body-content">${bodyContent}</div>
          ${attachmentsSection}
        </div>
      </body>
    </html>
  `;

  return htmlContent;
};
